import { jsPDF } from "jspdf";

import { getDayName, formatDateYMD, catchError } from 'scripts/common'

export const createPDF = (id, fetchedData, object, user, signature) => {

  const pdf = (id, data, object, user, signature) => {

    console.log('start pdf')

    let path = `dailies/daily`

    if (data === undefined) {

      alert('Error: daily id not found. Could not PDF.')

    } else if (data.signature === null || data.signature === '') {

      alert('The owner of this daily has not provided a signature. Therefore a PDF cannot be created until a signature is provided.')

    } else {

      console.log('before signature')

      let techSignature = data.signature.replace(/ /g, "+") //global replace of ' '

      let receivedBySignature = signature !== '' ? signature : data.receivedBySignature !== '' ? data.receivedBySignature.replace(/ /g, "+") : ''

      let receivedBy = data.dailiesstatus !== 'Signed' ? '' : data.receivedby === null ? '' : data.receivedby

      let dayName = getDayName(data.dailiesdate, true)
      let totalHours = String(Number(data.hours1) + Number(data.hours2) + Number(data.hours3) + Number(data.hours4)); //must be a string to print?

      let address, city, state, zip

      let doc = new jsPDF()

      //Create the PDF - Default export is a4 paper, portrait, using milimeters for units
      let xmin = 12; //17.5;
      let ymin = 32;
      let xmax = 196.5; //202;
      let ymax = 258 + 24; // extended 24 for testing final ymax
      let xtaskcode = xmin + 133.5; //151;
      let xcb = xmin + 178.5; //196;
      let spacing = 7.5;
      let spacingmemo = 10;
      let margin = 5;
      let xtaskcode2 = xtaskcode + ((xmax - xtaskcode)/2);
      let xtech = (xtaskcode/2 + xmin/2);

      let xday;
      let xspacing;
      let upperspacing;

      let trimStr; // this is used to trim some str which are too long to fit in the space given

      let imgData = 'data:image/png;base64,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';

      doc.setFont('times', 'normal')
      doc.setFontSize(12)

      console.log('after signature')

      let description = doc.splitTextToSize(data.description, (xmax - xmin - margin * 2 - 10)) // 8/5/2022 updated jspdf and the desc began to overflow the xMax, so -10 seems to account for overflow

      let lineCount = description.length // splitTextToSize actually turns description into an array!

      let maxHeight = (ymax - spacing * 6) - (ymin + spacingmemo + spacing * 6 - 4.25)
      //console.log('maxHeight: ' + maxHeight);
      //var maxLines = Math.floor(maxHeight / 3.505729); // round down to nearest whole integer 12px = 3.175mm? 1.25px = 0.330729mm padding
      var maxLines = 30 // f it, i counted the max line that fits in the dialy

      let pages = Math.ceil(lineCount / maxLines) || 1

      trimStr = doc.splitTextToSize(data.address + ', ' + data.city + ', ' + data.state + ' ' + data.zip, (xspacing * 2 - 2))

      console.log('before pages')

      for (let page=1; page <= pages; page++) {

        if ( page > 1) doc.addPage()

        doc.addImage(imgData, 'JPEG', 46, 15, 116, 15)

        //light gray
        doc.setFillColor(220, 220, 220);
        //doc.rect(xmin, ymin, xcb-xmin, ymin+spacingmemo-ymin, 'F');
        doc.rect(xtaskcode,ymax-spacing*6, xmax-xtaskcode, spacing, 'F');
        doc.rect(xtaskcode,ymax-spacing*4, xmax-xtaskcode, spacing, 'F');
        doc.rect(xtaskcode,ymax-spacing*2, xmax-xtaskcode, spacing, 'F');

        //black
        doc.setDrawColor(0, 0, 0);

        //outside frame
        doc.setLineWidth(1);
        doc.line(xmin, ymin, xmax, ymin); // horizontal top
        doc.line(xmin, ymin, xmin, ymax); // vertical left
        doc.line(xmin, ymax, xmax, ymax); // horizontal bottom
        doc.line(xmax, ymin, xmax, ymax); // vertical right

        //upper horizontal
        doc.setLineWidth(0.5);

        upperspacing = ymin+spacingmemo;
        doc.setLineWidth(1);
        doc.line(xmin, ymin+spacingmemo, xmax, ymin+spacingmemo);
        doc.setLineWidth(0.5);
        doc.line(xmin, upperspacing+spacing*3, xmax, upperspacing+spacing*3);
        doc.line(xmin, upperspacing+spacing*5, xmax, upperspacing+spacing*5);
        doc.setLineWidth(0.25);
        doc.line(xmin, upperspacing+spacing*1, xmax, upperspacing+spacing*1);
        doc.line(xmin, upperspacing+spacing*2, xmax, upperspacing+spacing*2);
        //doc.line(xmin, upperspacing+spacing*4, xmax, upperspacing+spacing*4); below equipment, text will wrap, so a line is not needed
        doc.setLineWidth(0.5);
        //doc.line(xcb, ymin+(spacingmemo/2), xmax, ymin+(spacingmemo/2)); //grading cb

        //upper vertical
        xday = 145;
        xspacing = (xmax-xmin)/4;

        //start text
        doc.setFont('times', 'bold');
        //doc.setFontType('bold');
        doc.setFontSize(14);

        if (data.dailiestype === 'inspector') {

          // gray header

          doc.setFillColor(220, 220, 220);
          doc.rect(xmin, ymin, xmax-xmin, ymin+spacingmemo-ymin, 'F');

          //black
          doc.setDrawColor(0, 0, 0);

          doc.text((xmax-xmin)/2 + xmin-50, ymin+spacingmemo/2+1, 'SPECIAL INSPECTOR DAILY FIELD REPORT');

          doc.setLineWidth(0.25);

          doc.setFontSize(8);

          doc.text(xmin+1, ymin+spacingmemo+spacing-4.25, 'JOB NO.');

          doc.text(xmin + xspacing/2+1, ymin+spacingmemo+spacing-4.25, 'CLIENT/PROJECT');

          doc.text(xday+1, ymin+spacingmemo+spacing-4.25, 'DAY');

          doc.text((xmax-xday)/2+xday+1, ymin+spacingmemo+spacing-4.25, 'DATE');

          doc.text(xmin+1, ymin+spacingmemo+spacing*2-4.25, 'LOCATION');

          doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-4.25, 'PERMIT #');

          doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-4.25, 'JURISDICTION');

          doc.text(xmin+1, ymin+spacingmemo+spacing*3-4.25, 'SUB CONTRACTOR');

          doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-4.25, 'FOREMAN');

          doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-4.25, 'WEATHER');

          //doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-4.25, 'YARDAGE TO DATE');

          doc.text(xmin+1, ymin+spacingmemo+spacing*4-4.25, 'EQUIPMENT');

          doc.line(xday, ymin+spacingmemo, xday, ymin+spacingmemo+spacing); //day
          doc.line((xmax-xday)/2+xday, ymin+spacingmemo, (xmax-xday)/2+xday, ymin+spacingmemo+spacing); //date
          doc.line(xmin + xspacing/2, ymin+spacingmemo, xmin + xspacing/2, ymin+spacingmemo+spacing); //client
          doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing, xmin + xspacing*2, ymin+spacingmemo+spacing*2); //project
          doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing, xmin + xspacing*3, ymin+spacingmemo+spacing*2); //yardage today
          doc.line(xmin + xspacing, ymin+spacingmemo+spacing*2, xmin + xspacing, ymin+spacingmemo+spacing*3); //foreman
          doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing*2, xmin + xspacing*2, ymin+spacingmemo+spacing*3); //weather
          doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing*2, xmin + xspacing*3, ymin+spacingmemo+spacing*3); //yardage to date

          //console.log('start signature');

          //Do signatures before rest, so that lines/text are not blocked by image box
          if (techSignature !== null && techSignature !== '') doc.addImage(techSignature, 'JPEG', xmin+1, ymax-spacing*3+6, 60, 15)

          //console.log('start receivedby');

          //if (object === 'sign') doc.addImage(receivedBySignature.current, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)

          if (data.dailiesstatus === 'Signed' && receivedBySignature !== '') doc.addImage(receivedBySignature, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)

          //console.log('end signatures');

          //lower vertical
          doc.setLineWidth(0.5);
          doc.line(xtech,ymax-spacing*1,xtech,ymax-spacing*3); //between tech and recieved by
          doc.line(xtaskcode,ymax-spacing*6,xtaskcode,ymax); //task code and hours
          doc.line(xtaskcode2,ymax-spacing*6,xtaskcode2,ymax); //task code and hours

          //lower horizontal - tech and recived by section
          doc.text(xmin+1, ymax-spacing*3+3, 'INSPECTOR (Print)');

          doc.text(xmin+1, ymax-spacing*2+3, 'INSPECTOR (Signature)');

          doc.text(xmin+1, ymax-spacing*1+3, 'INSPECTOR ID #');
          doc.text(xtech+1, ymax-spacing*3+3, 'RECEIVED BY (Print)');

          doc.text(xtech+1, ymax-spacing*2+3, 'RECEIVED BY (Signature)');

          doc.setLineWidth(0.5);
          doc.line(xmin, ymax-spacing*6, xtaskcode, ymax-spacing*6); // line for statement compliance
          doc.line(xmin, ymax-spacing*3, xtaskcode, ymax-spacing*3); // above received by print
          doc.line(xmin, ymax-spacing*2, xtaskcode, ymax-spacing*2); // above received by sig
          doc.line(xmin, ymax-spacing*1, xtaskcode, ymax-spacing*1); // above inspec id #

          //lower horizontal - task code and hours
          doc.text(xtaskcode+5, ymax-spacing*6+3, 'ACTIVITY');
          doc.text(xtaskcode+8, ymax-spacing*6+6, 'CODE');

          doc.text(xtaskcode2+7, ymax-spacing*6+4.5, 'HOURS');

          doc.text(xtaskcode+7, ymax-spacing*1+4.5, 'TOTAL');

          //Statement of compliance header
          doc.text(xmin + 1, ymax-spacing*6+3, 'STATEMENT OF COMPLIANCE');

          //Statement of compliance body
          let statement = 'I declare under penalty of perjury that the above statements are true, and that, to the best of my knowledge, the work described in this report has been performed / installed in compliance with the approved plans, project specifications, and all applicable codes.'
          statement = doc.splitTextToSize(statement, (xtaskcode - xmin - 2))
          doc.text(xmin + 1, ymax-spacing*5+3, statement)

          // add the text here

          doc.setFontSize(12);

          doc.text(xmin+1, ymax-spacing*1+6, data.inspectorId);

          doc.text(xmin+1, ymin+spacingmemo+spacing-1.25, data.jobnumber); //job number text

          trimStr = doc.splitTextToSize(data.client + ' / ' + data.project, (xday - xmin + xspacing - 2));

            doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, trimStr[0]); //client text

          doc.text(xday + 1, ymin+spacingmemo + spacing - 1.25, dayName); //day text
          doc.text((xmax - xday)/2 + xday + 1, ymin + spacingmemo + spacing - 1.25, data.dailiesdate); //date text

          address = data.address === null ? '' : data.address
          city = data.city === null ? '' : data.city
          state = data.state === null ? '' : data.state
          zip = data.zip === null ? '' : data.zip

          trimStr = doc.splitTextToSize(`${address}, ${city}, ${state} ${zip}`, (xspacing*2 - 2));

            doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //location text

          trimStr = doc.splitTextToSize(data.permitNo, (xspacing - 2));

            doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //project eng text

          trimStr = doc.splitTextToSize(data.jurisdiction, (xspacing - 2));

            doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //jurisdiction

          trimStr = doc.splitTextToSize(data.contractor, (xspacing - 2));

            doc.text(xmin+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //contractor

          trimStr = doc.splitTextToSize(data.foreman, (xspacing - 2));

            doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //foreman text

          trimStr = doc.splitTextToSize(data.weather, (xspacing - 2))

            doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //weather text

          //doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-1.25, data.yardagetodate); //yardage text

          trimStr = doc.splitTextToSize(data.equipment, (xmax-xmin)); //wraps text within specified space, does not account for y axis

            doc.text(xmin+1, ymin+spacingmemo+spacing*4-1.25, trimStr); //equipment text

          //see above before while startX
          //description = doc.splitTextToSize(description, (xmax-xmin)); //wraps text within specified space, does not account for y axis
          //doc.text(xmin+1, ymin+spacingmemo+spacing*6-4.25, description); //description text

          doc.text( xmin + margin, ymin + margin + spacingmemo + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
          description.splice(0, maxLines); // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc

        } else {

          // gray header

          doc.setFillColor(220, 220, 220);
          doc.rect(xmin, ymin, xcb-xmin, ymin+spacingmemo-ymin, 'F');
          doc.line(xcb, ymin+(spacingmemo/2), xmax, ymin+(spacingmemo/2)); //grading cb

          //black
          doc.setDrawColor(0, 0, 0);

          doc.text((xmax-xmin)/2 + xmin-30, ymin+spacingmemo/2+1, 'DAILY FIELD REPORT');
          //doc.text((48+xmin)/2+5, ymin+spacingmemo*0.75-1, String(isValidated.memoNo === null ? '' : isValidated.memoNo)); //memno text

          doc.setLineWidth(0.5);
          //doc.line(48, ymin, 48, ymin+spacingmemo); //memo
          doc.setFontSize(10);
          //doc.text(xmin+1, ymin+spacingmemo/2-1, 'MEMO');
          //doc.text(xmin+1, ymin+spacingmemo-1, 'NO.');

          doc.line(xcb, ymin, xcb, ymin+spacingmemo); //grading cb
          doc.text(xmax-25.5, ymin+spacingmemo/2-1, 'GRADING');
          doc.text(xmax-36, ymin+spacingmemo-1, 'POST-GRADING');

          //mark the grading phase with an X
          if (data.gradeid === 'RG') {
              doc.text(xcb+1.5, ymin+spacingmemo/2-1, 'X');
          }

          else if (data.gradeid === 'PG') {
              doc.text(xcb+1.5, ymin+spacingmemo-1, 'X');
          }

          doc.setLineWidth(0.25);

          doc.setFontSize(8);

          doc.text(xmin+1, ymin+spacingmemo+spacing-4.25, 'JOB NO.');

          doc.text(xmin + xspacing/2+1, ymin+spacingmemo+spacing-4.25, 'CLIENT/PROJECT');

          doc.text(xday+1, ymin+spacingmemo+spacing-4.25, 'DAY');

          doc.text((xmax-xday)/2+xday+1, ymin+spacingmemo+spacing-4.25, 'DATE');

          doc.text(xmin+1, ymin+spacingmemo+spacing*2-4.25, 'LOCATION/TRACT');

          doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-4.25, 'PROJECT ENG/GEO');

          doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-4.25, 'YARDAGE TODAY');

          doc.text(xmin+1, ymin+spacingmemo+spacing*3-4.25, 'CONTRACTOR');

          doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-4.25, 'FOREMAN');

          doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-4.25, 'WEATHER');

          doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-4.25, 'YARDAGE TO DATE');

          doc.text(xmin+1, ymin+spacingmemo+spacing*4-4.25, 'EQUIPMENT');

          doc.line(xday, ymin+spacingmemo, xday, ymin+spacingmemo+spacing); //day
          doc.line((xmax-xday)/2+xday, ymin+spacingmemo, (xmax-xday)/2+xday, ymin+spacingmemo+spacing); //date
          doc.line(xmin + xspacing/2, ymin+spacingmemo, xmin + xspacing/2, ymin+spacingmemo+spacing); //client
          doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing, xmin + xspacing*2, ymin+spacingmemo+spacing*2); //project
          doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing, xmin + xspacing*3, ymin+spacingmemo+spacing*2); //yardage today
          doc.line(xmin + xspacing, ymin+spacingmemo+spacing*2, xmin + xspacing, ymin+spacingmemo+spacing*3); //foreman
          doc.line(xmin + xspacing*2, ymin+spacingmemo+spacing*2, xmin + xspacing*2, ymin+spacingmemo+spacing*3); //weather
          doc.line(xmin + xspacing*3, ymin+spacingmemo+spacing*2, xmin + xspacing*3, ymin+spacingmemo+spacing*3); //yardage to date

          //console.log('start signature');

          //Do signatures before rest, so that lines/text are not blocked by image box
          if (techSignature !== null && techSignature !== '') doc.addImage(techSignature, 'JPEG', xmin+1, ymax-spacing*3+6, 60, 15)

          //console.log('start receivedby');

          //if (object === 'sign') doc.addImage(receivedBySignature.current, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)

          if (data.dailiesstatus === 'Signed' && receivedBySignature !== '') doc.addImage(receivedBySignature, 'JPEG', xtech+1, ymax-spacing*3+6, 60, 15)

          //console.log('end signatures');

          //lower vertical
          doc.setLineWidth(0.5);
          doc.line(xtech,ymax-spacing*1,xtech,ymax-spacing*3); //vertical between tech and received by
          doc.line(xtaskcode,ymax-spacing*6,xtaskcode,ymax); // vertical left of task code
          doc.line(xtaskcode2,ymax-spacing*6,xtaskcode2,ymax); // vertical left of hours

          //lower horizontal - tech and recived by section

          let jobTitle = data.dailiestype === 'engineer' ? 'ENGINEER' : data.dailiestype === 'geologist' ? 'GEOLOGIST' : 'TECHNICIAN'

          doc.text(xmin+1, ymax-spacing*3+3, `${jobTitle} (Print)`);

          doc.text(xmin+1, ymax-spacing*2+3, `${jobTitle} (Signature)`);

          doc.text(xmin+1, ymax-spacing*1+3, 'DISTRIBUTION');
          doc.text(xtech+1, ymax-spacing*3+3, 'RECEIVED BY (Print)');

          doc.text(xtech+1, ymax-spacing*2+3, 'RECEIVED BY (Signature)');

          doc.setLineWidth(0.5);
          doc.line(xmin, ymax-spacing*3, xtaskcode, ymax-spacing*3); // above received by print
          doc.line(xmin, ymax-spacing*2, xtaskcode, ymax-spacing*2); // above received by sig
          doc.line(xmin, ymax-spacing*1, xtaskcode, ymax-spacing*1); // above distribution

          //lower horizontal - task code and hours
          doc.text(xtaskcode+8, ymax-spacing*6+3, 'TASK');
          doc.text(xtaskcode+8, ymax-spacing*6+6, 'CODE');

          doc.text(xtaskcode2+7, ymax-spacing*6+4.5, 'HOURS');

          doc.text(xtaskcode+7, ymax-spacing*1+4.5, 'TOTAL');

          //console.log('start adding database text');

          // add the text here

          doc.setFontSize(12);

          doc.text(xmin+1, ymin+spacingmemo+spacing-1.25, data.jobnumber); //job number text

          //console.log(`client: ${data.client}`)

          trimStr = doc.splitTextToSize(data.client + ' / ' + data.project, (xday - xmin + xspacing - 2));

          //console.log(`trimStr: ${trimStr}`)

          //doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, client + ' / ' + project); //client text
          doc.text(xmin + xspacing / 2 + 1, ymin+spacingmemo+spacing - 1.25, trimStr[0]); //client text

          //console.log(`trimStr: ${trimStr}`)

          doc.text(xday + 1, ymin+spacingmemo + spacing - 1.25, dayName); //day text
          doc.text((xmax - xday)/2 + xday + 1, ymin + spacingmemo + spacing - 1.25, data.dailiesdate); //date text
          //doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, address + ', ' + city + ', ' + county + ' ' + state + ' ' + zip); //location text

          address = data.address === null ? '' : data.address
          city = data.city === null ? '' : data.city
          state = data.state === null ? '' : data.state
          zip = data.zip === null ? '' : data.zip

          trimStr = doc.splitTextToSize(`${address}, ${city}, ${state} ${zip}`, (xspacing*2 - 2));

            doc.text(xmin+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //location text

          trimStr = doc.splitTextToSize(data.pe + ' / ' + data.pg, (xspacing - 2));

            doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //project eng text

          trimStr = doc.splitTextToSize(data.yardagetoday, (xspacing - 2));

            doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*2-1.25, trimStr[0]); //jurisdiction

          trimStr = doc.splitTextToSize(data.contractor, (xspacing - 2));

            doc.text(xmin+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //contractor

          trimStr = doc.splitTextToSize(data.foreman, (xspacing - 2));

            doc.text(xmin + xspacing*1+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //foreman text

          trimStr = doc.splitTextToSize(data.weather, (xspacing - 2))

            doc.text(xmin + xspacing*2+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //weather text

          trimStr = doc.splitTextToSize(data.yardagetodate, (xspacing - 2))

            doc.text(xmin + xspacing*3+1, ymin+spacingmemo+spacing*3-1.25, trimStr[0]); //yardage text

          trimStr = doc.splitTextToSize(data.equipment, (xmax-xmin)); //wraps text within specified space, does not account for y axis

            doc.text(xmin+1, ymin+spacingmemo+spacing*4-1.25, trimStr); //equipment text

          //see above before while startX
          //description = doc.splitTextToSize(description, (xmax-xmin)); //wraps text within specified space, does not account for y axis
          //doc.text(xmin+1, ymin+spacingmemo+spacing*6-4.25, description); //description text

          doc.text( xmin + margin, ymin + margin + spacingmemo + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
          description.splice(0, maxLines); // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc

        }

        doc.text(xmin+1, ymax-spacing*3+6, data.fullname);
        doc.text(xtech+1, ymax-spacing*3+6, String(receivedBy));

        doc.text(xtaskcode+10, ymax-spacing*5+4.5, data.taskcode1);
        doc.text(xtaskcode+10, ymax-spacing*4+4.5, data.taskcode2);
        doc.text(xtaskcode+10, ymax-spacing*3+4.5, data.taskcode3);
        doc.text(xtaskcode+10, ymax-spacing*2+4.5, data.taskcode4);

        doc.text(xtaskcode2+11, ymax-spacing*5+4.5, data.hours1);
        doc.text(xtaskcode2+11, ymax-spacing*4+4.5, data.hours2);
        doc.text(xtaskcode2+11, ymax-spacing*3+4.5, data.hours3);
        doc.text(xtaskcode2+11, ymax-spacing*2+4.5, data.hours4);

        doc.text(xtaskcode2+11, ymax-spacing*1+4.5, totalHours);

        // text finished, wrap up footer

        doc.setFontSize(11);
        doc.text(xtaskcode+7, ymax+4.5, 'PAGE');
        doc.text(xtaskcode2-2, ymax+4.5, String(page));
        doc.text(xtaskcode2+5, ymax+4.5, 'OF');
        doc.text(xtaskcode2+15, ymax+4.5, String(pages));
        doc.setFontSize(9);
        doc.setFont('times', 'bolditalic');
        //doc.setFontType('bolditalic');
        doc.text(xmin, ymax+4.5, '1011 North Armando Street, Anaheim CA 92806 (714) 630-1626');

        doc.setLineWidth(0.5);
        doc.line(xtaskcode, ymax-spacing*6, xmax, ymax-spacing*6); // above activity code
        doc.line(xtaskcode, ymax-spacing*5, xmax, ymax-spacing*5); // below activity code
        doc.setLineWidth(0.25);
        doc.line(xtaskcode, ymax-spacing*4, xmax, ymax-spacing*4); // horiz lines for activity codes and hours
        doc.line(xtaskcode, ymax-spacing*3, xmax, ymax-spacing*3);
        doc.line(xtaskcode, ymax-spacing*2, xmax, ymax-spacing*2);
        doc.line(xtaskcode,ymax-spacing*1, xmax, ymax-spacing*1);

      }

      console.log('before upload')

      let blob = doc.output('blob')

      if (object === 'preview') {

        return URL.createObjectURL(blob)

      } else {

        //console.log('upload daily')

        let fileData = new FormData()
        fileData.append('filePath', 'dailies')
        fileData.append('fileName', `daily${data.id}.pdf`)
        fileData.append('filePDF', blob)

        fetch('/api/uploadDaily', {
          method: 'post',
          body: fileData
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + JSON.stringify(result))

            //console.log('daily uploaded')

          },
          (error) => {

            //alert('Error: could not upload Daily. Contact and admin.')
            catchError(data.jobNumber, data.gradeId, '', 'uploadDaily', JSON.stringify(error), user.username, user.device)
          }
        )

      }

    }

  }

  // alright run pdf() here

  if (object === 'preview') {

    //console.log(`preview fetchedData: ${JSON.stringify(fetchedData)}`)

    let data = fetchedData.find(data => data.id === id)

    //console.log(`preview data: ${JSON.stringify(data)}`)

    if (data.signature === undefined) {
      //alert('Please click refresh first, then preview. This is temporary and only for dailies which were just created.')

      alert('Preview is temporarily disabled. Sorry.')
    } else {
      return pdf(id, data, object, user, signature)
    }

  } else {

    console.log('selectDaily')

    fetch('/api/selectDaily', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({id: id})
    })
    .then(res=>res.json())
    .then(
      (result) => {

        let data = {...result[0], dailiesdate: formatDateYMD(result[0].dailiesdate)}

        //console.log(`data found: ${JSON.stringify(data)}`)

        pdf(id, data, object, user, signature)

      },
      (error) => {
        catchError('', '', `daily${id}`, 'selectDailyforPDF', JSON.stringify(error), user.username, user.device)
      }
    )

    // .then(res => res.json())
    // .then(result => {
    //
    //   let data = {...result[0], dailiesdate: formatDateYMD(data.dailiesdate)}
    //
    //   console.log(`data found: ${JSON.stringify(data)}`)
    //
    //   pdf(id, data, object, user, signature)
    //
    // })
    // .catch(error => {
    //   //alert('Error: could not edit daily. Contact and admin.')
    //   catchError('', '', `daily${id}`, 'selectDailyforPDF', JSON.stringify(error), user.username, user.device)
    // })

  }

}

export const pdfTests = (data, job, prefixes, report) => {

  // sort ascending
  data.sort((a, b) => Number(a.testno) - Number(b.testno) || a.suf.localeCompare(b.suf))

  //console.log(`pdf data: ${JSON.stringify(data)}`)

  //Create the PDF - Default export is a4 paper, portrait, using milimeters for units
  // Document of 8.5 inch width and 11 inch high
  let doc = new jsPDF({
    orientation: 'l',
    unit: 'in',
    format: 'letter'
  })

  let font12 = 0.16667
  let row = 20
  let top = 1.75
  let bottom = 7.75
  let rowInc = (bottom - top) / row
  let page = report.page === '' ? 1 : Number(report.page)

  const addPageBorders = () => {

    //start text
    doc.setFont('times', 'bold')
    //doc.setFontType('bold');
    doc.setFontSize(12)

    doc.text(0.5, 0.75, `${job.client}`, 'left')
    doc.text(5.5, 0.5, `TABLE ${report.tableName}`, 'center')
    doc.text(10.5, 0.5, `${report.reportDate}`, 'right')
    doc.text(10.5, 0.75, `JN: ${job.jobNumber}`, 'right')
    doc.text(5.5, 1, 'SUMMARY OF FIELD DENSITY TEST RESULTS', 'center')

    // page border
    doc.setLineWidth(0.025)
    doc.line(0.5, 1.05, 10.5, 1.05) // top line
    doc.line(0.5, 1.05, 0.5, bottom) // left line
    doc.line(0.5, bottom, 10.5, bottom) // bottom line
    doc.line(10.5, 1.05, 10.5, bottom) // right line

    // header
    doc.text(1, 1.25, 'Test\nNo.', 'center')
    doc.text(1.9, 1.25, 'Test\nDate', 'center')
    doc.text(2.65, 1.25, 'Test\nType\n(*)', 'center')
    doc.text(3.75, 1.25, 'Location', 'center')
    doc.text(3, 1.5, 'Northing', 'left')
    doc.text(4.4, 1.5, 'Easting', 'right')
    doc.text(4.8, 1.25, 'Elev./\nDepth', 'center')
    doc.text(5.45, 1.25, 'Moist.\nContent\n(%)', 'center')
    doc.text(6.2, 1.25, 'Dry\nDensity\n(pcf)', 'center')
    doc.text(6.95, 1.25, 'Max Dry\nDensity\n(pcf)', 'center')
    doc.text(7.7, 1.25, 'Opt.\nMoist.\n(%)', 'center')
    doc.text(8.4, 1.25, 'Max\nCurve\nNo.', 'center')
    doc.text(9.05, 1.25, 'Relative\nComp.\n(%)', 'center')
    doc.text(9.7, 1.25, `Req'd\nComp.\n(%)`, 'center')
    doc.text(10.25, 1.25, 'Pass/\nFail', 'center')

    // vertical lines

    doc.setLineWidth(0.015)

    doc.line(1.45, 1.05, 1.45, bottom) // test
    doc.line(2.35, 1.05, 2.35, bottom) // date
    doc.line(2.9, 1.05, 2.9, bottom) // type
    doc.line(3.75, 1.75, 3.75, bottom) // northing
    doc.line(4.5, 1.05, 4.5, bottom) // easting
    doc.line(5.07, 1.05, 5.07, bottom) // elev/depth
    doc.line(5.85, 1.05, 5.85, bottom) // mc
    doc.line(6.55, 1.05, 6.55, bottom) // dry dens
    doc.line(7.35, 1.05, 7.35, bottom) // max dry dens
    doc.line(8.05, 1.05, 8.05, bottom) // opt moist
    doc.line(8.7, 1.05, 8.7, bottom) // curve
    doc.line(9.4, 1.05, 9.4, bottom) // relative
    doc.line(10, 1.05, 10, bottom) // req'd

    doc.line(0.5, 1.05, 0.5, bottom) // left line

    // horizontal lines

    for (let i = 0; i < row; i++) {

      doc.line(0.5, top + rowInc * i, 10.5, top + rowInc * i) // top line

    }

  }

  const addFooter = () => {

    doc.text(10.5, 8, `A-${page}`, 'right')
    doc.setFont('times', 'bolditalic')
    doc.text(0.5, 8, `ALBUS & ASSOCIATES, INC.`, 'left')
    doc.setFontSize(9)
    doc.text(5.5, 7.9, `* See last page of this table for explanations`, 'center')

  }

  addPageBorders()
  addFooter()

  for (var i = 0, j = 0; i < data.length; i++, j++) {

    if (i % (row) === 0 && i !== 0) {
      page++
      doc.addPage()
      addPageBorders()
      addFooter()
      j = 0
    }

    //let jn = data[i].jobnumber === null ? '' : data[i].jobnumber
    //let gd = data[i].gradeid === null ? '' : data[i].gradeid === 'RG' ? 'Grading' : data[i].gradeid === 'PG' ? 'Post' : ''
    let pre = data[i].pre === null ? '' : data[i].pre
    let number = data[i].testno === null ? '' : data[i].testno
    let suf = data[i].suf === null ? '' : data[i].suf
    let testNo = `${pre} ${number} ${suf}`
    let dryDens = data[i].drydens === null ? '' : data[i].drydens
    let moistCont = data[i].moistcont === null ? '' : data[i].moistcont
    let md = `${dryDens} @ ${moistCont}`
    let optD = data[i].optd === null ? '' : data[i].optd
    let optM = data[i].optm === null || data[i].optm === 0 ? '' : data[i].optm
    let curve = data[i].curve === null ? '' : data[i].curve
    let max = `${curve} - ${optD} @ ${optM}`
    let reqComp = data[i].reqcomp === null ? '' : data[i].reqcomp
    let relComp = data[i].relcomp === null ? '' : data[i].relcomp
    let elevD = data[i].elevd === null ? '' : data[i].elevd
    let passFail = data[i].passfail === null ? '' : data[i].passfail === 'P' ? 'pass' : data[i].passfail === 'F' ? 'fail' : '?'
    // let entryBy = data[i].entryby !== null && data[i].entryby !== '' ? data[i].entryby : data[i].tech !== null ? data[i].tech : ''
    // let entryTime = data[i].entrytime === null ? '' : data[i].entrytime
    // let modBy = data[i].modby !== null && data[i].modby !== '' ? data[i].modby : ''
    // let modTime = data[i].modtime === null ? '' : data[i].modtime

    //start text
    doc.setFont('times', 'bold')
    //doc.setFontType('bold');
    doc.setFontSize(11)

    doc.text(1, top + 0.23 + rowInc * j, testNo, 'center')
    doc.text(1.9, top + 0.23 + rowInc * j, data[i].testdate, 'center')
    doc.text(2.65, top + 0.23 + rowInc * j, data[i].testtype, 'center')
    doc.text(3.325, top + 0.23 + rowInc * j, String(data[i].north), 'center')
    doc.text(4.125, top + 0.23 + rowInc * j, String(data[i].east), 'center')
    doc.text(4.8, top + 0.23 + rowInc * j, String(elevD), 'center')
    doc.text(5.45, top + 0.23 + rowInc * j, String(moistCont), 'center')
    doc.text(6.2, top + 0.23 + rowInc * j, String(dryDens), 'center')
    doc.text(6.95, top + 0.23 + rowInc * j, String(optD), 'center')
    doc.text(7.7, top + 0.23 + rowInc * j, String(optM), 'center')
    doc.text(8.4, top + 0.23 + rowInc * j, String(curve), 'center')
    doc.text(9.05, top + 0.23 + rowInc * j, String(relComp), 'center')
    doc.text(9.7, top + 0.23 + rowInc * j, String(reqComp), 'center')
    doc.text(10.25, top + 0.23 + rowInc * j, String(passFail), 'center')

    if (i === data.length - 1) {
      page++

      doc.addPage('letter', 'portrait')
      doc.setFontSize(12)
      doc.text(4.75, 1, 'EXPLANATION OF FIELD DENSITY TEST CODES', 'center')
      doc.setFontSize(11)
      doc.setFont('times', 'bolditalic')
      doc.text(0.5, 1.25, 'PREFIX CODE DESIGNATION', 'left')
      doc.text(3, 1.5, 'GRADING', 'left')
      doc.text(0.5, 1.5, 'POST GRADING', 'left')
      doc.text(3, 6, 'CODES FOLLOWING\nTHE TEST NUMBER', 'left')
      doc.text(3, 7, 'TEST TYPE', 'left')
      doc.text(3, 8, 'MAX. CURVE NO.', 'left')

      doc.setFont('times', 'normal')

      let inc = font12 * 1.5
      let l = 0
      let m = 0
      for (let i=0; i < prefixes.length; i++) {

        if (prefixes[i].gradeid === 'PG') {
          doc.text(0.5, 1.5 + inc * (l + 1), `${prefixes[i].prefix} - ${prefixes[i].description} ${prefixes[i].prefix === 'UC' ? '*' : ''}`, 'left')
          l++
        } else if (prefixes[i].gradeid === 'RG') {
          doc.text(3, 1.5 + inc * (m + 1), `${prefixes[i].prefix} - ${prefixes[i].description} ${prefixes[i].prefix === 'SW' ? '*' : ''}`, 'left')
          m++
        }

      }

      doc.text(3, 6.4, 'A-C: Subsequent retest of failed density test after recompaction\nR: Material removed', 'left')
      doc.text(3, 7.2, 'D: Drive Cylinder Test per ASTM D2937\nS: Sand Cone Test per ASTM D1556\nN: Nuclear Gauge Test per ASTM D6938', 'left')
      doc.text(3, 8.2, 'A-Z/1-10: Corresponds to the Maximum Curve Designation listed in Table B-1', 'left')

      doc.text(8, 10.5, `A-${page}`, 'right')
      doc.setFont('times', 'bolditalic')
      doc.text(0.5, 10.5, `ALBUS & ASSOCIATES, INC.`, 'left')
      doc.setFontSize(9)
      doc.text(0.5, 9.8, `*Utility Common Trench: Gas, Cable TV, Edison, Gas, Misc. Utility`, 'left')
      doc.text(0.5, 9.95, `*Semental Wall (Keystone, Verdura Wall, Loffel Wall, Crib Wall, etc.)`, 'left')
    }

  }


    let blob = doc.output('blob')

    //if (object === 'preview') {

      return URL.createObjectURL(blob)

    //} else {

      // let fileData = new FormData()
      // fileData.append('filePath', 'dailies')
      // fileData.append('fileName', `daily${data.id}.pdf`)
      // fileData.append('filePDF', blob)
      //
      // fetch('/api/uploadDaily', {
      //   method: 'post',
      //   body: fileData
      // })
      // .then(res=>res.json())
      // .then(
      //   (result) => {
      //     //console.log('result: ' + JSON.stringify(result))
      //
      //   },
      //   (error) => {
      //
      //     //alert('Error: could not upload Daily. Contact and admin.')
      //     catchError(data.jobNumber, data.gradeId, '', 'uploadDaily', JSON.stringify(error), user.username, user.device)
      //   }
      // )

    //}



}

export const pdfMaterial = (data, job, report) => {

  // sort ascending
  data = data.sort((a, b) => Number(a.castDate) - Number(b.castDate))

  //console.log(`pdf data: ${JSON.stringify(data)}`)

  //Create the PDF - Default export is a4 paper, portrait, using milimeters for units
  // Document of 8.5 inch width and 11 inch high
  let doc = new jsPDF({
    orientation: 'l',
    unit: 'in',
    format: 'letter'
  })

  let font12 = 0.16667
  let row = 30
  let top = 1.75
  let bottom = 7.75
  let rowInc = (bottom - top) / row
  let rowHeight = 0.2
  let page = report.page === '' ? 1 : Number(report.page)
  let positionBottom = top // draws line horizontally below rows, so track position

  const addPageBorders = () => {

    //start text
    doc.setFont('times', 'bold')
    //doc.setFontType('bold');
    doc.setFontSize(12)

    doc.text(0.5, 0.75, `${job.client}`, 'left')
    doc.text(5.5, 0.5, `TABLE ${report.tableName}`, 'center')
    doc.text(10.5, 0.5, `${report.reportDate}`, 'right')
    doc.text(10.5, 0.75, `JN: ${job.jobNumber}`, 'right')
    doc.text(5.5, 1, 'SUMMARY OF MATERIAL COMPRESSION TESTS', 'center')

    // page border
    doc.setLineWidth(0.05)
    doc.line(0.5, 1.05, 10.5, 1.05) // top line
    doc.line(0.5, 1.05, 0.5, bottom) // left line
    doc.line(0.5, bottom, 10.5, bottom) // bottom line
    doc.line(10.5, 1.05, 10.5, bottom) // right line

    // header
    doc.text(1.225, 1.25, 'Location', 'center')
    doc.text(2.45, 1.25, 'Cast\nDate', 'center')
    doc.text(2.9, 1.25, 'Set', 'center')
    doc.text(3.32, 1.25, 'Spec.\nStren.\n(psi)', 'center')

    // let b = 3.32
    // let col1 = 0.47
    // let col2 = 0.88
    // let col3 = 1.18

    let b = 3.55    
    let col1 = 0.24
    let col2 = 0.65
    let col3 = 0.95
    let col = 1.1

    // let b1 = 3.79
    // let b2 = 4.2
    // let b3 = 4.5
    // let col = 0.71

    //1
    doc.text(b + col * 0 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 0 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 0 + col3, 1.25, '%', 'center')

    //2
    doc.text(b + col * 1 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 1 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 1 + col3, 1.25, '%', 'center')
    
    //3
    doc.text(b + col * 2 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 2 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 2 + col3, 1.25, '%', 'center')
    
    //4
    doc.text(b + col * 3 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 3 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 3 + col3, 1.25, '%', 'center')
    
    //5
    doc.text(b + col * 4 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 4 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 4 + col3, 1.25, '%', 'center')
    
    //6
    doc.text(b + col * 5 + col1, 1.25, 'Max.\nStress\n(psi)', 'center')
    doc.text(b + col * 5 + col2, 1.25, 'Age\n(d)', 'center')
    doc.text(b + col * 5 + col3, 1.25, '%', 'center')

    doc.text(10.3, 1.25, 'Pass\nFail', 'center')

    // vertical lines

    doc.setLineWidth(0.025)

    doc.line(2.1, 1.05, 2.1, bottom) // location
    doc.line(2.75, 1.05, 2.75, bottom) // date
    doc.line(3.05, 1.05, 3.05, bottom) // field set
    //doc.line(3.75, 1.75, 3.75, bottom) // northing
    doc.line(3.55, 1.05, 3.55, bottom) // specified stren

    b = 3.55    
    col1 = 0.5
    col2 = 0.8
    col3 = 1.1

    doc.line(b + col3 * 0 + col1, 1.05, b + col3 * 0 + col1, bottom) // stren1
    doc.line(b + col3 * 0 + col2, 1.05, b + col3 * 0 + col2, bottom) // age1
    doc.line(b + col3 * 0 + col3, 1.05, b + col3 * 0 + col3, bottom) // %1

    doc.line(b + col3 * 1 + col1, 1.05, b + col3 * 1 + col1, bottom) // stren1
    doc.line(b + col3 * 1 + col2, 1.05, b + col3 * 1 + col2, bottom) // age1
    doc.line(b + col3 * 1 + col3, 1.05, b + col3 * 1 + col3, bottom) // %1

    doc.line(b + col3 * 2 + col1, 1.05, b + col3 * 2 + col1, bottom) // stren1
    doc.line(b + col3 * 2 + col2, 1.05, b + col3 * 2 + col2, bottom) // age1
    doc.line(b + col3 * 2 + col3, 1.05, b + col3 * 2 + col3, bottom) // %1

    doc.line(b + col3 * 3 + col1, 1.05, b + col3 * 3 + col1, bottom) // stren1
    doc.line(b + col3 * 3 + col2, 1.05, b + col3 * 3 + col2, bottom) // age1
    doc.line(b + col3 * 3 + col3, 1.05, b + col3 * 3 + col3, bottom) // %1

    doc.line(b + col3 * 4 + col1, 1.05, b + col3 * 4 + col1, bottom) // stren1
    doc.line(b + col3 * 4 + col2, 1.05, b + col3 * 4 + col2, bottom) // age1
    doc.line(b + col3 * 4 + col3, 1.05, b + col3 * 4 + col3, bottom) // %1

    doc.line(b + col3 * 5 + col1, 1.05, b + col3 * 5 + col1, bottom) // stren1
    doc.line(b + col3 * 5 + col2, 1.05, b + col3 * 5 + col2, bottom) // age1
    doc.line(b + col3 * 5 + col3, 1.05, b + col3 * 5 + col3, bottom) // %1    

    doc.line(0.5, 1.05, 0.5, bottom) // left line

    // horizontal lines

    doc.line(0.5, positionBottom, 10.5, positionBottom) // top line

    // for (let i = 0; i < row; i++) {

    //   doc.line(0.5, top + rowInc * i, 10.5, top + rowInc * i) // top line

    // }

  }

  const addFooter = () => {

    doc.text(10.5, 8, `A ${page}`, 'right')
    doc.setFont('times', 'bolditalic')
    doc.text(0.5, 8, `ALBUS & ASSOCIATES, INC.`, 'left')
    doc.setFontSize(9)
    doc.text(5.5, 7.9, `* See last page of this table for explanations`, 'center')

  }

  addPageBorders()
  addFooter()

  //console.log(`data: ${JSON.stringify(data)}`)  

  for (var i = 0, j = 0; i < data.length; i++, j++) {

    // if (i % (row) === 0 && i !== 0) {
    //   page++
    //   doc.addPage()
    //   addPageBorders()
    //   addFooter()
    //   j = 0
    // }    

    //start text
    doc.setFont('times', 'bold')
    //doc.setFontType('bold');
    doc.setFontSize(9)

    let structure = ''

    switch (data[i].structureType) {
      case 'slabOnGrade':
        structure = 'Slab on Grade'
        break
      case 'elevatedSlab':
        structure = 'Elevated Slab'
        break
      case 'footing':
        structure = 'Footing'
        break
      case 'pile':
        structure = 'Pile'
        break
      case 'pier':
        structure = 'Pier'
        break
      case 'column':
        structure = 'Column'
        break
      case 'wallPanel':
        structure = 'Wall Panel'
        break
      case 'beam':
        structure = 'Beam'
        break
      case 'sidewalk':
        structure = 'Sidewalk'
        break
      case 'curbAndGutter':
        structure = 'Curb and Gutter'
        break
      case 'pavement':
        structure = 'Pavement'
        break
      case 'masonry':
        structure = 'Masonry'
        break
      case 'other':
        structure = 'Other'
        break
      default:
        console.log('unknown structure')
    }
    
    let material = data[i].materialType.substring(0,4)
    let specimen = data[i].specimenType.substring(0,4)

    let combinedText = `${structure}, ${data[i].represents}, ${data[i].diameter}" ${material}, ${specimen}`

    let buffer = 0.15

    let splitLocation = doc.splitTextToSize(combinedText, 1.55);

    //positionBottom += rowHeight * splitLocation.length

    if (positionBottom + rowHeight * splitLocation.length < bottom) {

      let positionOtherText = positionBottom + buffer

      for (let a=0; a < splitLocation.length; a++) {

        doc.text(0.55, positionBottom + buffer, splitLocation.slice(a, a + 1), 'left')

        positionBottom += 0.2

      }

      //if (i % (row) === 0 && i !== 0) {

      

        //j = 0
      //}

      //doc.text(0.55, top + buffer + rowInc * j, splitLocation.slice(0, 1), 'left')
      //doc.text(0.55, top + 0.3 + rowInc * j, splitLocation.slice(1, 2), 'left')

      // console.log(`
      // splitLocation: ${splitLocation.length}
      // `)

      

      doc.line(0.5, positionBottom, 10.5, positionBottom) // top line

      // console.log(`
      // location: ${combinedText}
      // split: ${splitLocation.slice(0, 1)}
      // `)

      

      doc.text(2.43, positionOtherText, data[i].castDate, 'center')

      doc.setFontSize(11)

      //doc.text(0.55, top + 0.23 + rowInc * j, data[i].location, 'left')
      
      doc.text(2.9, positionOtherText, data[i].fieldMarking, 'center')
      doc.text(3.31, positionOtherText, String(data[i].designStrength), 'center')    

      let b = 3.55    
      let col1 = 0.24
      let col2 = 0.65
      let col3 = 0.95
      let col = 1.1

      // let baseWidth = 3.31
      // let sWidth = 0.49
      // let aWidth = 0.38
      // let pWidth = 0.32
      // let col = sWidth + aWidth + pWidth
      // let col2 = sWidth + aWidth
      //top + 0.23
          
      doc.text(b + col * 0 + col1, positionOtherText, String(data[i].strength1), 'center')
      doc.text(b + col * 0 + col2, positionOtherText, String(data[i].age1 === '0' ? '' : data[i].age1), 'center')
      doc.text(b + col * 0 + col3, positionOtherText, String(data[i].percent1), 'center')

      doc.text(b + col * 1 + col1, positionOtherText, String(data[i].strength2), 'center')
      doc.text(b + col * 1 + col2, positionOtherText, String(data[i].age2 === '0' ? '' : data[i].age2), 'center')
      doc.text(b + col * 1 + col3, positionOtherText, String(data[i].percent2), 'center')

      doc.text(b + col * 2 + col1, positionOtherText, String(data[i].strength3), 'center')
      doc.text(b + col * 2 + col2, positionOtherText, String(data[i].age3 === '0' ? '' : data[i].age3), 'center')
      doc.text(b + col * 2 + col3, positionOtherText, String(data[i].percent3), 'center')

      doc.text(b + col * 3 + col1, positionOtherText, String(data[i].strength4), 'center')
      doc.text(b + col * 3 + col2, positionOtherText, String(data[i].age4 === '0' ? '' : data[i].age4), 'center')
      doc.text(b + col * 3 + col3, positionOtherText, String(data[i].percent4), 'center')

      doc.text(b + col * 4 + col1, positionOtherText, String(data[i].strength5), 'center')
      doc.text(b + col * 4 + col2, positionOtherText, String(data[i].age5 === '0' ? '' : data[i].age5), 'center')
      doc.text(b + col * 4 + col3, positionOtherText, String(data[i].percent5), 'center')

      doc.text(b + col * 5 + col1, positionOtherText, String(data[i].strength6), 'center')
      doc.text(b + col * 5 + col2, positionOtherText, String(data[i].age6 === '0' ? '' : data[i].age6), 'center')
      doc.text(b + col * 5 + col3, positionOtherText, String(data[i].percent6), 'center')

      let c = 0
      let p = 0

      if (data[i].age1 === '28' && (data[i].percent1 !== '' && data[i].percent1 !== null)) {
        c+=1
        p+=Number(data[i].percent1)
      }

      if (data[i].age2 === '28' && (data[i].percent2 !== '' && data[i].percent2 !== null)) {
        c+=1
        p+=Number(data[i].percent2)
      }

      if (data[i].age3 === '28' && (data[i].percent3 !== '' && data[i].percent3 !== null)) {
        c+=1
        p+=Number(data[i].percent3)
      }

      if (data[i].age4 === '28' && (data[i].percent4 !== '' && data[i].percent4 !== null)) {
        c+=1
        p+=Number(data[i].percent4)
      }

      if (data[i].age5 === '28' && (data[i].percent5 !== '' && data[i].percent5 !== null)) {
        c+=1
        p+=Number(data[i].percent5)
      }

      if (data[i].age6 === '28' && (data[i].percent6 !== '' && data[i].percent6 !== null)) {
        c+=1
        p+=Number(data[i].percent6)
      }

      if (c > 1 && p !== 0) {
        let pf = Math.round(p/c) > 100 ? 'P' : 'F'
        if (pf === 'F') doc.setTextColor(255, 0, 0)
        doc.text(b + col * 6 + 0.15, positionOtherText, String(pf), 'center')
      }

      doc.setTextColor(0, 0, 0)

    } else {

      positionBottom = top
      doc.addPage()
      addPageBorders()
      addFooter()      

    }

    // if (i === data.length - 1) {
    //   page++
    //
    //   doc.addPage('letter', 'portrait')
    //   doc.setFontSize(12)
    //   doc.text(4.75, 1, 'EXPLANATION OF FIELD DENSITY TEST CODES', 'center')
    //   doc.setFontSize(11)
    //   doc.setFont('times', 'bolditalic')
    //   doc.text(0.5, 1.25, 'PREFIX CODE DESIGNATION', 'left')
    //   doc.text(3, 1.5, 'GRADING', 'left')
    //   doc.text(0.5, 1.5, 'POST GRADING', 'left')
    //   doc.text(3, 6, 'CODES FOLLOWING\nTHE TEST NUMBER', 'left')
    //   doc.text(3, 7, 'TEST TYPE', 'left')
    //   doc.text(3, 8, 'MAX. CURVE NO.', 'left')
    //
    //   doc.setFont('times', 'normal')
    //
    //   let inc = font12 * 1.5
    //   let l = 0
    //   let m = 0
    //   for (let i=0; i < prefixes.length; i++) {
    //
    //     if (prefixes[i].gradeid === 'PG') {
    //       doc.text(0.5, 1.5 + inc * (l + 1), `${prefixes[i].prefix} - ${prefixes[i].description} ${prefixes[i].prefix === 'UC' ? '*' : ''}`, 'left')
    //       l++
    //     } else if (prefixes[i].gradeid === 'RG') {
    //       doc.text(3, 1.5 + inc * (m + 1), `${prefixes[i].prefix} - ${prefixes[i].description} ${prefixes[i].prefix === 'SW' ? '*' : ''}`, 'left')
    //       m++
    //     }
    //
    //   }
    //
    //   doc.text(3, 6.4, 'A-C: Subsequent retest of failed density test after recompaction\nR: Material removed', 'left')
    //   doc.text(3, 7.2, 'D: Drive Cylinder Test per ASTM D2937\nS: Sand Cone Test per ASTM D1556\nN: Nuclear Gauge Test per ASTM D6938', 'left')
    //   doc.text(3, 8.2, 'A-Z/1-10: Corresponds to the Maximum Curve Designation listed in Table B-1', 'left')
    //
    //   doc.text(8, 10.5, `A ${page}`, 'right')
    //   doc.setFont('times', 'bolditalic')
    //   doc.text(0.5, 10.5, `ALBUS & ASSOCIATES, INC.`, 'left')
    //   doc.setFontSize(9)
    //   doc.text(0.5, 9.8, `*Utility Common Trench: Gas, Cable TV, Edison, Gas, Misc. Utility`, 'left')
    //   doc.text(0.5, 9.95, `*Semental Wall (Keystone, Verdura Wall, Loffel Wall, Crib Wall, etc.)`, 'left')
    // }    

  }

  let blob = doc.output('blob')

  return URL.createObjectURL(blob)

}
